import { createElement } from 'react'
import type { RouteObject } from 'react-router-dom'
import type { createStore } from 'jotai'
import { authPageLinks } from './pageLinks'
import * as LoginStore from './stores/LoginStore'
import * as RegisterStore from './stores/RegisterStore'
import * as VerifyEmailStore from './stores/VerifyEmailStore'
import * as RequestPasswordResetStore from './stores/RequestPasswordResetStore'
import * as ResetPasswordStore from './stores/ResetPasswordStore'
import * as AuthCallbackStore from './stores/AuthCallbackStore'
import Login from './pages/Login'
import Register from './pages/Register'
import VerifyEmail from './pages/VerifyEmail'
import RequestPasswordReset from './pages/RequestPasswordReset'
import ResetPassword from './pages/ResetPassword'
import AuthCallback from './pages/AuthCallback'

type Store = ReturnType<typeof createStore>

export function createAuthRoutes(store: Store): RouteObject[] {
  const routes: RouteObject[] = [
    {
      path: authPageLinks.Login(),
      element: createElement(Login),
      loader: async () => {
        await LoginStore.loader(store)
        return null
      },
    },
    {
      path: authPageLinks.Register(),
      element: createElement(Register),
      loader: async () => {
        await RegisterStore.loader(store)
        return null
      },
    },
    {
      path: authPageLinks.RequestPasswordReset(),
      element: createElement(RequestPasswordReset),
      loader: async () => {
        await RequestPasswordResetStore.loader(store)
        return null
      },
    },
    {
      path: authPageLinks.ResetPassword(),
      element: createElement(ResetPassword),
      loader: async () => {
        await ResetPasswordStore.loader(store)
        return null
      },
    },
    {
      path: authPageLinks.AuthCallback(),
      element: createElement(AuthCallback),
      loader: async () => {
        return AuthCallbackStore.loader(store)
      },
    },
  ]

  if (import.meta.env?.VITE_REQUIRE_EMAIL_VERIFICATION !== 'false') {
    routes.push({
      path: authPageLinks.VerifyEmail(),
      element: createElement(VerifyEmail),
      loader: async () => {
        await VerifyEmailStore.loader(store)
        return null
      },
    })
  }

  return routes
}
